import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7a5bf775"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "aspect-h-3 pt-4 w-full" }
const _hoisted_2 = { class: "image-container" }
const _hoisted_3 = ["src"]
const _hoisted_4 = ["src"]
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "slider-line",
  "aria-hidden": "true"
}, null, -1))
const _hoisted_6 = {
  class: "slider-button",
  "aria-hidden": "true"
}
const _hoisted_7 = {
  key: 1,
  xmlns: "http://www.w3.org/2000/svg",
  width: "30",
  height: "30",
  fill: "currentColor",
  viewBox: "0 0 256 256"
}
const _hoisted_8 = /*#__PURE__*/_createStaticVNode("<rect width=\"256\" height=\"256\" fill=\"none\" data-v-7a5bf775></rect><line x1=\"128\" y1=\"40\" x2=\"128\" y2=\"216\" fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"16\" data-v-7a5bf775></line><line x1=\"96\" y1=\"128\" x2=\"16\" y2=\"128\" fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"16\" data-v-7a5bf775></line><polyline points=\"48 160 16 128 48 96\" fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"16\" data-v-7a5bf775></polyline><line x1=\"160\" y1=\"128\" x2=\"240\" y2=\"128\" fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"16\" data-v-7a5bf775></line><polyline points=\"208 96 240 128 208 160\" fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"16\" data-v-7a5bf775></polyline>", 6)
const _hoisted_14 = [
  _hoisted_8
]
const _hoisted_15 = { class: "flex justify-between pt-2 sm:text-sm text-xs" }
const _hoisted_16 = { class: "justify-self-center" }
const _hoisted_17 = { class: "flex justify-center items-center pt-2" }
const _hoisted_18 = ["disabled"]
const _hoisted_19 = ["max"]
const _hoisted_20 = ["disabled"]
const _hoisted_21 = {
  key: 0,
  class: "text-red text-center"
}
const _hoisted_22 = { class: "justify-self-center" }
const _hoisted_23 = { class: "flex justify-center items-center pt-2" }
const _hoisted_24 = ["disabled"]
const _hoisted_25 = ["max"]
const _hoisted_26 = ["disabled"]
const _hoisted_27 = {
  key: 0,
  class: "text-red text-center"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LoadingSpinner = _resolveComponent("LoadingSpinner")!
  const _component_ChevronLeftIcon = _resolveComponent("ChevronLeftIcon")!
  const _component_ChevronRightIcon = _resolveComponent("ChevronRightIcon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass(["container", ['container' + _ctx.camera]])
    }, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("img", {
          alt: "Before image",
          class: "image-before slider-image",
          src: _ctx.beforeImg.url ? _ctx.beforeImg.url : _ctx.default_img
        }, null, 8, _hoisted_3),
        _createElementVNode("img", {
          alt: "After image",
          class: "image-after slider-image",
          src: _ctx.afterImg.url ? _ctx.afterImg.url : _ctx.default_img
        }, null, 8, _hoisted_4)
      ]),
      _createElementVNode("input", {
        type: "range",
        min: "0",
        max: "100",
        value: "50",
        "aria-label": "Percentage of before photo shown",
        class: _normalizeClass(["slider", ['slider' + _ctx.camera]])
      }, null, 2),
      _hoisted_5,
      _createElementVNode("div", _hoisted_6, [
        (_ctx.loadingImage)
          ? (_openBlock(), _createBlock(_component_LoadingSpinner, {
              key: 0,
              size: " h-6 w-6"
            }))
          : (_openBlock(), _createElementBlock("svg", _hoisted_7, _hoisted_14))
      ])
    ], 2),
    _createElementVNode("div", _hoisted_15, [
      _createElementVNode("div", _hoisted_16, [
        _createElementVNode("div", _hoisted_17, [
          _createElementVNode("button", {
            disabled: !_ctx.beforeImg.previous,
            type: "button",
            class: _normalizeClass(['nav-arrows', !_ctx.beforeImg.previous ? 'opacity-30' : '']),
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.prevBeforeImg()))
          }, [
            _createVNode(_component_ChevronLeftIcon, {
              class: _normalizeClass(['h-3.5 w-3.5 text-gray-500', { 'text-yellow-500': _ctx.beforeDateError }]),
              "aria-hidden": "true"
            }, null, 8, ["class"])
          ], 10, _hoisted_18),
          _withDirectives(_createElementVNode("input", {
            type: "date",
            max: _ctx.maxDate,
            class: "p-0.5 border-transparent focus:border-yellow focus:shadow-none focus:ring-0 text-xs sm:text-sm bg-transparent",
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.beforeTime) = $event)),
            onChange: _cache[2] || (_cache[2] = ($event: any) => (_ctx.changeBeforeTime(($event.target as HTMLInputElement).value)))
          }, null, 40, _hoisted_19), [
            [_vModelText, _ctx.beforeTime]
          ]),
          _createElementVNode("button", {
            disabled: !_ctx.beforeImg.next,
            type: "button",
            class: _normalizeClass(['nav-arrows', !_ctx.beforeImg.next ? 'opacity-30' : '']),
            onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.nextBeforeImg()))
          }, [
            _createVNode(_component_ChevronRightIcon, {
              class: _normalizeClass([{ 'text-yellow-500': _ctx.beforeDateError }, 'h-3.5 w-3.5 text-gray-500']),
              "aria-hidden": "true"
            }, null, 8, ["class"])
          ], 10, _hoisted_20)
        ]),
        (_ctx.beforeDateError)
          ? (_openBlock(), _createElementBlock("small", _hoisted_21, _toDisplayString(_ctx.$t("camera.compare.no_image")), 1))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_22, [
        _createElementVNode("div", _hoisted_23, [
          _createElementVNode("button", {
            disabled: !_ctx.afterImg.previous,
            onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.prevAfterImg())),
            type: "button",
            class: _normalizeClass(['nav-arrows', !_ctx.afterImg.previous ? 'opacity-30' : ''])
          }, [
            _createVNode(_component_ChevronLeftIcon, {
              class: "h-3.5 w-3.5 text-gray-500",
              "aria-hidden": "true"
            })
          ], 10, _hoisted_24),
          _withDirectives(_createElementVNode("input", {
            type: "date",
            max: _ctx.maxDate,
            class: "p-0.5 border-transparent focus:border-yellow focus:shadow-none focus:ring-0 sm:text-sm text-xs bg-transparent",
            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.afterTime) = $event)),
            onChange: _cache[6] || (_cache[6] = ($event: any) => (_ctx.changeAfterTime(($event.target as HTMLInputElement).value)))
          }, null, 40, _hoisted_25), [
            [_vModelText, _ctx.afterTime]
          ]),
          _createElementVNode("button", {
            disabled: !_ctx.afterImg.next,
            onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.nextAfterImg())),
            type: "button",
            class: _normalizeClass(['nav-arrows', !_ctx.afterImg.next ? 'opacity-30' : ''])
          }, [
            _createVNode(_component_ChevronRightIcon, {
              class: "h-3.5 w-3.5 text-gray-500",
              "aria-hidden": "true"
            })
          ], 10, _hoisted_26)
        ]),
        (_ctx.afterDateError)
          ? (_openBlock(), _createElementBlock("small", _hoisted_27, _toDisplayString(_ctx.$t("camera.compare.no_image")), 1))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}